import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { HttpClient, HttpParams } from "@angular/common/http";

import { PriceServiceDetail } from '../models';
import { ResponseModel } from '../models/response.model';
import { GeneralService } from './general.service';
import { PersistenceService } from 'angular-persistence';
import { environment } from '../../environments/environment';
import { DataFilterViewModel, PriceServiceDetailExcelViewModel } from '../view-model/index';
import { MessageService } from 'primeng/components/common/messageservice';
import { SelectModel } from '../models/select.model';

@Injectable()
export class PriceServiceDetailService extends GeneralService {
  constructor(protected messageService: MessageService, protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
    super(messageService, httpClient, persistenceService, environment.apiPostUrl, "priceServiceDetail");
  }

  public GetByPriceService(dataFilter: DataFilterViewModel): Observable<ResponseModel> {
    return super.postCustomApi("GetByPriceService", dataFilter);
  }

  public UploadExcelPriceService(dataExcels: PriceServiceDetailExcelViewModel): Observable<ResponseModel> {
    return super.postCustomApi("UploadExcelPriceService", dataExcels);
  }

  async updateFromProvince(model) {
    let res = await super.postCustomApi("UpdateFromProvince", model).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as any;
    return data;
  }
  
  getByPriceServiceId(priceSerivceId: any, areaGroupId): Observable<ResponseModel> {
    let params = new HttpParams();
    params = params.append("priceServiceId", priceSerivceId);
    params = params.append("areaGroupId", areaGroupId);
    return super.getCustomApi("GetByPriceServiceId", params);
  }

  async getByPriceServiceIdAsync(priceSerivceId: any, areaGroupId: any): Promise<any> {
    const res = await this.getByPriceServiceId(priceSerivceId, areaGroupId).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as any;
    return data;
  }

  updatePriceServices(model: PriceServiceDetail[]) {
    return super.postCustomApi("UpdatePriceServices", model);
  }
  async updatePriceServicesAsync(model: PriceServiceDetail[]): Promise<PriceServiceDetail[]> {
    const res = await this.updatePriceServices(model).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as PriceServiceDetail[];
    return data;
  }
  creatPriceServices(model: PriceServiceDetail) {
    return super.postCustomApi("create", model);
  }
  async creatPriceServicesAsync(model: PriceServiceDetail): Promise<PriceServiceDetail> {
    const res = await this.creatPriceServices(model).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as PriceServiceDetail;
    return data;
  }

  getByPriceServiceDetail(model: any) {
    return super.postCustomApi("GetByPriceServiceDetail", model);
  }
  async getByPriceServiceDetailAsync(model: any): Promise<any> {
    const res = await this.getByPriceServiceDetail(model).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data;
    return data;
  }

  updateAreaDistricts(model: any) {
    return super.postCustomApi("UpdateAreaDistricts", model);
  }

  async updateAreaDistrictsAsync(model: any): Promise<any> {
    const res = await this.updateAreaDistricts(model).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data;
    return data;
  }

  async getListCodeRoutingByHubId(fromHubId: any, toHubId: any):Promise<SelectModel[]>{
    let param = new HttpParams();
    param = param.append("fromHubId",fromHubId);
    param = param.append("toHubId",toHubId);
    const res = await super.getCustomApi("GetListCodeRoutingByHubId",param).toPromise();
    if(!this.isValidResponse(res)) return;
    const selectModel = [];
    const datas = res.data as any[];

    selectModel.push({ label: "-- Chọn dữ liệu --", data: null, value: null });
    datas.forEach(element => {
      selectModel.push({
        label: `${element.code} - ${element.name}`,
        data: element,
        value: element.id
      });
    });
    return selectModel;
  }
}

